export const ROUTE_CONFIG = {
    login: { path: '/', title: 'Login' },
    home: { path: '/home', title: 'Dashboard' },
    projects: { path: '/projects', title: 'Manage Projects' },
    clouds: { path: '/clouds', title: 'Migration Appliances' },
    startMigrations: { path: '/start-migrations', title: 'Start Migration' },
    sources: { path: '/sources', title: 'Source Inventory' },
    moveGroups: { path: '/move_groups', title: 'Move Groups' },
    binaryAssets: { path: '/binary_assets', title: 'Migration Extensions' },
    editProfile: { path: '/edit_profile', title: 'Edit Profile' },
    migrationProfilesList: { path: '/migration_profiles_list', title: 'Migration Profiles' },
    migrationSettings: { path: '/migration_settings', title: 'Migration Settings' },
    migrationSetup: { path: '/migration_setup', title: 'Migration Setup' },
    migrationList: { path: '/migration_list', title: 'View Migrations' },
    migrationPlanner: { path: '/migration_planner', title: 'Migration Tracker' },
    migrationDetails: { path: '/migration_details', title: 'Migration Details' },
    migrationPlan: { path: '/migration_plan', title: 'Migration Plan' },
    backupApplianceSetup: { path: '/backup_appliance_setup', title: 'Setup' },
    backupPolicies: { path: '/backup_policies', title: 'Backup Policies' },
    recoveryApplianceSetup: { path: '/recovery_appliance_setup', title: 'Setup' },
    recoveryDrPolicies: { path: '/recovery_dr_policies', title: 'DR Policies' },
    reportingMigrationProjectPlan: { path: '/reporting_migration_project_plan', title: 'Migration Project Plan' },
    reportingMigrationStatus: { path: '/reporting_migration_status', title: 'Workload Migrations Status' },
    reportingMigrationByUser: { path: '/reporting_migration_by_user', title: 'Migrations by User' },
    reportingEntitlementStatus: { path: '/reporting_entitlement_status', title: 'Entitlement Status' },
    reportingEntitlementsConsumption: {
        path: '/reporting_entitlements_consumption',
        title: 'Entitlements Consumption',
    },
    reportingMigrationStatusDiff: { path: '/reporting_migration_status', title: 'Workload Delta Migrations Status' },
    reportingBackupPolicies: { path: '/reporting_backup_policies', title: 'Backup Policies' },
    reportingBackups: { path: '/reporting_backups', title: 'Backups and Recoveries' },
    register: { path: '/register', title: 'Register' },
    reportingDrPolicies: { path: '/reporting_dr_policies', title: 'DR Policies' },
    reportingDrReplications: { path: '/reporting_dr_replications', title: 'DR Replications and Recoveries' },
    auditLog: { path: '/audit_log', title: 'Audit Log' },
    reportingMigrationsAwsTargetInstance: {
        path: '/reporting_migrations_aws_target_instance',
        title: 'AWS Target Instance Report',
    },
    admin: { path: '/admin', title: 'Admin' },
    archivedMigrations: { path: '/archived_migrations', title: 'Archived Migrations' },
    scheduledMigrations: { path: '/scheduled_migrations', title: 'Scheduled Migrations' },
    sourceDiscovery: { path: '/source_discovery', title: 'Source Discovery' },
    sourceInspection: { path: '/source_inspection', title: 'Source Inspection' },
    viewDmProfile: { path: '/view_dm_profile', title: 'View Profile' },
    users: { path: '/users', title: 'Users' },
};

// Discovery route configuration
export const DISCOVERY_ROUTE_CONFIG = {
    base: { path: '/discovery', title: 'Discovery' },
    inventory: { path: '/discovery/inventory', title: 'Inventory' },
    moveGroupsAndApps: { path: '/discovery/groups', title: 'Move Groups and Apps' },
    rvTools: { path: '/discovery/import/rvtools', title: 'RVTools' },
    awsTransform: { path: '/discovery/import/aws-transform', title: 'AWS Transform' },
};

export const ROUTES = Object.keys(ROUTE_CONFIG).reduce((acc, key) => {
    acc[key] = ROUTE_CONFIG[key].path;
    return acc;
}, {});

export const ROUTE_TITLES = Object.values(ROUTE_CONFIG).reduce((acc, { path, title }) => {
    acc[path] = title;
    return acc;
}, {});

export const DISCOVERY_ROUTES = Object.keys(DISCOVERY_ROUTE_CONFIG).reduce((acc, key) => {
    acc[key] = DISCOVERY_ROUTE_CONFIG[key].path;
    return acc;
}, {});

export const DISCOVERY_ROUTE_TITLES = Object.values(DISCOVERY_ROUTE_CONFIG).reduce((acc, { path, title }) => {
    acc[path] = title;
    return acc;
}, {});

// Accepts optional search query string as second argument
export const getPageTitleFromPath = (pathname, search = '') => {
    // Special handling for /reporting_migration_status with query params
    if (pathname === '/reporting_migration_status') {
        if (search.includes('type=full')) {
            return 'Workload Migrations Status';
        }
        if (search.includes('type=differential')) {
            return 'Workload Delta Migrations Status';
        }
    }

    if (ROUTE_TITLES[pathname]) {
        return ROUTE_TITLES[pathname];
    }

    if (DISCOVERY_ROUTE_TITLES[pathname]) {
        return DISCOVERY_ROUTE_TITLES[pathname];
    }

    // Try to match base path for nested routes
    const basePath = '/' + pathname.split('/').filter(Boolean)[0];
    if (ROUTE_TITLES[basePath]) {
        return ROUTE_TITLES[basePath];
    }

    // Try to match discovery base path
    if (DISCOVERY_ROUTE_TITLES[basePath]) {
        return DISCOVERY_ROUTE_TITLES[basePath];
    }

    return 'Dashboard';
};

// Helper to get the nested discovery path by removing the base
export const getNestedDiscoveryPath = (fullPath) => {
    const base = DISCOVERY_ROUTE_CONFIG.base.path;
    return fullPath.startsWith(base) ? fullPath.slice(base.length).replace(/^\//, '') : fullPath;
};
